const ENTER_KEY_CODE = 13;

export const isClick = (event) => event.type === 'click';

export const isEnterKeyDown = (event) => {
  return event.type === 'keydown' && event.keyCode === ENTER_KEY_CODE;
};

export const onEnterKey = (callback) => (event) => {
  if (event.keyCode === ENTER_KEY_CODE && callback) {
    event.preventDefault();

    callback(event);
  }

  return null;
};

export const preventDefault = (event) => event.preventDefault();

const isMacPlatform = () => {
  try {
    return /(Mac|iPhone|iPod|iPad)/i.test(global.navigator.platform);
  } catch (error) {
    return false;
  }
};

/**
 * Whether the event is exactly the "save" shortcut: Cmd+Enter on macOS,
 * Ctrl+Enter (or Meta+Enter) elsewhere, with no other modifier held.
 * Same semantics as is-key-combo's `isKeyCombo(event, 'cmd+enter')`: on macOS
 * Ctrl is its own key, so Ctrl+Enter does not match there.
 */
export const isCmdEnter = (event, isMac = isMacPlatform()) => {
  const keyCode = event.which || event.keyCode || event.charCode;

  if (keyCode !== ENTER_KEY_CODE || event.shiftKey || event.altKey) {
    return false;
  }

  if (isMac) {
    return Boolean(event.metaKey) && !event.ctrlKey;
  }

  // off macOS both Meta and Ctrl count as "cmd", so exactly one must be held
  return Boolean(event.metaKey) !== Boolean(event.ctrlKey);
};
